import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { TranslocoService } from '@ngneat/transloco';

import { Item } from '../../../../interfaces/item';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { LogoutService } from '../../../Authentication/auth/logout.service';
import { LanguageServiceService } from '../../../../services/language-service.service';
import { WalletService } from '../../../../services/wallet';
import { isPlatformBrowser, Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {

  currentLanguage!: string | null;
  userData!: users;

  contentReady = true;
  classToggled = false;

  userimage = '';
  userPhone = '';
  userName = '';
  userfirstname = '';
  userlastname = '';
  userInstgram = '';
  userTiktok = '';

  id = '';
  balance: any = 0;

  hasItems = false;
  itemData!: Item;

  isMobile = false;
  isDeliveryHero = false;
  isAr = false;

  token: any = null;

  private isBrowser: boolean;

  constructor(
    private _profileService: ProfileService,
    private _logoutService: LogoutService,
    private _languageService: LanguageServiceService,
    private _userService: UserService,
    private location: Location,
    private router: Router,
    private walletService: WalletService,
    private deviceService: DeviceDetectorService,
    private transloco: TranslocoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // ================= INIT =================
  ngOnInit(): void {

    if (this.isBrowser) {
      const savedLang = localStorage.getItem('language') || 'en';

      this.currentLanguage = savedLang;
      this.isAr = savedLang === 'ar';

      // ✅ Set Transloco Language
      this.transloco.setActiveLang(savedLang);

      this.token = localStorage.getItem('token');

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }


    this.userId();
  }
  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/Home']);
    }
  }
  // ================= USER =================
  userId(): void {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.id = data.user_id;
        this.getUserItems(this.id);
        this.loadUserBalance(this.id);
      },
      error: () => {
        this.contentReady = false;
      },
    });
  }

  getUserItems(id?: any): void {

    this.isMobile = this.isBrowser
      ? this.deviceService.isMobileDevice()
      : false;

    this.contentReady = true;

    this._profileService.getuserinfo(id).subscribe({
      next: (res) => {
        this.userData = res;

        if (this.isBrowser) {
          localStorage.setItem('user', JSON.stringify(this.userData));
        }

        this.userName = res.username;
        this.userfirstname = res.first_name;
        this.userlastname = res.last_name;
        this.userInstgram = res.instagram_link;
        this.userTiktok = res.tiktok_link;
        this.userPhone = res.phone;
        this.userimage = this.changeUrl(res.image);

        this.hasItems = false;
        this.contentReady = false;
      },
      error: () => {
        this.contentReady = false;
      }
    });
  }

  // ================= WALLET =================
  loadUserBalance(id: any): void {
    this.walletService.getUserWallet(id).subscribe({
      next: (res) => {
        this.balance = res.balance;
      },
      error: () => {
        this.balance = 0;
      }
    });
  }

  // ================= LANGUAGE =================
  toggleLanguage(): void {
    if (!this.isBrowser) return;

    const newLang = this.currentLanguage === 'en' ? 'ar' : 'en';

    this.currentLanguage = newLang;
    this.isAr = newLang === 'ar';

    // ✅ Switch Transloco
    this.transloco.setActiveLang(newLang);

    // ✅ Save Language
    localStorage.setItem('language', newLang);

    // ✅ Notify Service
    this._languageService.changeLanguage(newLang);
  }


  // ================= LOGOUT =================
  logout(): void {

    if (!this.isBrowser) return;

    this.contentReady = true;

    this._logoutService.logout(this.token).subscribe({
      next: () => {
        localStorage.removeItem('cart');
        localStorage.removeItem('cartCount');
        localStorage.removeItem('username');
        localStorage.removeItem('token');
        localStorage.removeItem('posId');

        window.location.reload();
      },
      error: () => {
        this.contentReady = false;
        localStorage.removeItem('token');
      },
    });
  }

  // ================= HELPERS =================
  changeUrl(url: string): string {
    return url ? url.replace('/storage', '') : '';
  }
}
